import styled from '@emotion/styled';
import { JobListIntersectionProvider, mqDown, mqUp } from 'rwl-ui';
import { SharedLayoutProps } from './Layout';
import { useRef } from 'react';

const MainContentScreens = styled.div`
    flex: 1;
    position: relative;
    display: flex;
    flex-direction: row;

    overflow: hidden;
    ${mqDown('sm')} {
        transform: translateX(calc(-100% * var(--rwl-job-list-visible)));
        overflow: visible;
    }

    transition: transform 0.3s ease-in-out;
`;

const MainContentScreen = styled.div`
    ${mqDown('sm')} {
        position: absolute;
        inset: 0;
    }

    ${mqUp('sm')} {
        position: relative;
    }
`;

const JobListContainer = styled(MainContentScreen)`
    overflow-y: scroll;
    scrollbar-gutter: stable;
    padding: var(--rwl-spacing-md);
    min-width: 300px;

    ${mqUp('sm')} {
        flex-basis: 40%;
    }
    ${mqDown('sm')} {
        position: absolute;
        left: 100%;
        width: 100%;
    }
`;

const MapContainer = styled(MainContentScreen)`
    ${mqUp('sm')} {
        flex: 1;
    }

    width: 100%;

    ${mqUp('sm')} {
        flex-basis: 60%;
    }

    ${mqUp('md')} {
        flex-basis: 0%;
    }
`;

export const Content = (props: SharedLayoutProps) => {
    const jobListIntersectionRoot = useRef<HTMLDivElement>(null);

    return (
        <MainContentScreens id="MainContentScreens">
            <JobListIntersectionProvider
                value={{ rootEl: jobListIntersectionRoot.current }}
            >
                <JobListContainer
                    id="JobListContainer"
                    ref={jobListIntersectionRoot}
                >
                    {props.JobListContent}
                </JobListContainer>
            </JobListIntersectionProvider>
            <MapContainer id="MapContainer">{props.MapContent}</MapContainer>
        </MainContentScreens>
    );
};
